export const sleep = async (time: number) => {
  return new Promise<boolean>((resolve) =>
    setTimeout(() => resolve(true), time)
  );
};
